import styled from "styled-components";
import media from "constants/media";

export const BalanceContainer = styled.div`
    display: flex;
    flex-direction: column;

    padding: 4px 0;

    ${media.mdUp`
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    `}
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${media.mdUp`
        flex-direction: row;    
        justify-content: flex-start;
    `}
`;

export const DataField = styled.div`
    margin-bottom: 20px;

    ${media.mdUp`    
        margin-bottom: 0;
        margin-right: 50px;
    `}
`;

export const Label = styled.div`
    color: var(--color-darkNight);
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;

    ${media.mdUp`
        font-size: 16px;
        line-height: 25px;
        text-align: left;
    `}
`;

export const Data = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;

    color: var(--color-darkNight);
    font-size: 25px;
    font-family: var(--font-DINProCondensed);
    line-height: 30px;
    letter-spacing: 1px;

    ${media.mdUp`
    justify-content: flex-start;

        margin-top: 6px;
        font-size: 32px;
        line-height: 40px;
        text-align: left;
    `}
`;
